import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { get as _get } from 'lodash';

import { DsModalService } from '@amfam/ui-kit';

import { PhotoThumbnail } from '../../models/photo-thumbnail';

@Component({
  selector: 'ds-claim-photo-list',
  templateUrl: './claim-photo-list.component.html',
  styleUrls: ['./claim-photo-list.component.scss'],
  standalone: false
})
export class ClaimPhotoListComponent implements OnInit, OnChanges {
  @Input() thumbnailList: PhotoThumbnail[];
  @Input() totalFileSize: number;
  @Input() noOfRows: number;
  @Input() readyToUploadThumbnailCount: number;
  @Input() uploadProcessed: boolean;
  @Input() missingData: boolean;
  @Output() removePhotoEvent = new EventEmitter();
  @Output() cancelUploadEvent = new EventEmitter();
  @Output() uploadPhotosEvent = new EventEmitter();
  @Output() confirmUploadEvent = new EventEmitter();
  @Output() retryUploadEvent = new EventEmitter();

  uploadReady = false;
  uploadInitiated = false;

  modalId = 'goBack-modal';

  ngOnInit() {}

  constructor(private modalService: DsModalService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      _get(changes, 'readyToUploadThumbnailCount') &&
      changes.readyToUploadThumbnailCount.currentValue === 0 &&
      changes.readyToUploadThumbnailCount.previousValue !== undefined
    ) {
      this.uploadInitiated = true;
    }
    if (_get(changes, 'noOfRows') && changes.noOfRows.previousValue !== undefined) {
      if (changes.noOfRows.currentValue > changes.noOfRows.previousValue) {
        this.uploadReady = false;
        this.uploadInitiated = false;
        this.uploadProcessed = false;
      }
    }
  }

  // Modal is opened when Go Back is clicked
  openGoBackModal() {
    this.modalService.open(this.modalId);
  }
  // Emits photo to be removed by parent component
  removePhoto(photo: any) {
    this.removePhotoEvent.emit(photo);
    this.thumbnailList = this.thumbnailList.filter(thumbnail => thumbnail !== photo);
    this.onPhotoInputChange();
  }

  // Emits photo to retry upload with
  retryUpload(photo: any) {
    this.retryUploadEvent.emit(photo);
  }

  // Emit event to upload all
  uploadPhotos() {
    this.thumbnailList.forEach(thumbnail => {
      if (!thumbnail.uploadSuccess) {
        thumbnail.uploadInProgress = true;
        thumbnail.uploadPercent = 0;
      }
    });
    this.uploadPhotosEvent.emit(this.thumbnailList);
    this.uploadInitiated = true;
  }

  // On category or description change, enable upload button if required details is entered
  onPhotoInputChange() {
    let requiredData = true;
    this.thumbnailList.forEach(thumbnail => {
      if (
        !thumbnail.category ||
        (thumbnail.category === 'Other' && !thumbnail.description) ||
        thumbnail.description.match(/[^A-Za-z0-9 ,.?!’']+/g)
      ) {
        requiredData = false;
      }
    });
    this.uploadReady = requiredData;
  }

  // Emits to parent to indicate that the user has clicked 'Done'
  confirmUpload() {
    this.confirmUploadEvent.emit(this.thumbnailList);
  }

  // Emits to parent to cancel upload and clear photos
  cancelUpload() {
    this.cancelUploadEvent.emit();
    this.modalService.close(this.modalId);
  }

  stayHere() {
    this.modalService.close(this.modalId);
  }
}
